
import type { SVGProps } from 'react';
const SvgSpecialMoments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#special-moments_svg__a)">
      <path
        fill="#263E6A"
        d="M15.12 2.57a.57.57 0 1 1-1.141 0 .57.57 0 0 1 1.141 0m-5.058.386a.57.57 0 1 0 0 1.142.57.57 0 0 0 0-1.142m5.242.377a.422.422 0 1 0 0 .844.422.422 0 0 0 0-.844M8.738 4.608a.422.422 0 1 0 0 .844.422.422 0 0 0 0-.844m5.142-.129a.306.306 0 1 0 0 .613.306.306 0 0 0 0-.613m-5.258-1.83a.306.306 0 1 0 0 .613.306.306 0 0 0 0-.612m11.165 18.192a.335.335 0 0 0-.392-.266l-1.65.319-1-5.201.002-.003c.72-1.062 1.49-2.566 1.06-4.793l-.923-4.785a.335.335 0 1 0-.659.127l.187.965-2.329.448a.335.335 0 1 0 .127.658l2.329-.447.61 3.16c.397 2.058-.392 3.437-.846 4.124-.677-.469-1.922-1.455-2.319-3.512l-.536-2.777a.335.335 0 1 0-.658.127l.536 2.777c.428 2.22 1.697 3.33 2.758 4.047l1.002 5.212-1.63.315a.335.335 0 1 0 .126.658l3.94-.76a.336.336 0 0 0 .265-.393m-8.47-14.95-.898 4.789c-.418 2.23-1.688 3.345-2.747 4.068l-.003.002-.98 5.205 1.651.31a.336.336 0 0 1-.124.659l-3.943-.74a.335.335 0 0 1 .124-.659l1.633.306.982-5.215c-.724-1.058-1.496-2.555-1.079-4.778l.898-4.789a.335.335 0 1 1 .66.124l-.899 4.79c-.386 2.058.41 3.433.867 4.118.674-.473 1.915-1.466 2.301-3.525l.594-3.164-1.877-.354a.335.335 0 0 1 .124-.659l1.876.353.181-.965a.335.335 0 1 1 .66.124"
      />
    </g>
    <defs>
      <clipPath id="special-moments_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpecialMoments;
